import React, { useState } from "react";
import { CloseIcon, CopyIcon, CopySuccessIcon } from "../SvgIcon";
import moment from "moment-timezone";

const ActivityDetails = ({ onClose, activityDetails }) => {
  const [copiedUserId, setCopiedUserId] = useState(false);

  const handleCopy = (text, setter) => {
    if (text) {
      navigator.clipboard.writeText(text);
      setter(true);
      setTimeout(() => setter(false), 1500);
    }
  };

  const getChannelFromProvider = (provider) => {
    const p = (provider || "").toLowerCase();
    if (p === "sendgrid") return "Email";
    if (p === "firebase") return "Push";
    if (p === "twilio") return "SMS";
    return provider || "-";
  };

  const getChannelIcon = (channel) => {
    if (channel === "Email") return "✉️";
    if (channel === "Push") return "🔔";
    if (channel === "SMS") return "💬";
    return "-";
  };

  const getStatusClass = (status) => {
    const s = (status || "").toLowerCase();
    if (s === "sent" || s === "delivered") return "sent";
    if (s === "failed") return "failed";
    if (s === "abandoned") return "abandoned";
    if (s === "queued") return "queued";
    return "default";
  };

  const channelDispatches = (activityDetails?.activityLogs || []).map((log) => {
    const channel = getChannelFromProvider(log?.channel);
    return {
      channel,
      status: log?.status
        ? log?.status.charAt(0).toUpperCase() + log?.status.slice(1)
        : "-",
      provider: log?.provider || "-",
      messageId: log?.providerMsgId || "-",
      recipient: log?.recepient || "-",
    };
  });

  return (
    <div className="right-modal activity-details-modal">
      {/* Modal Header */}
      <div className="modal-header">
        <div className="modal-title">
          <h2 className="font-semibold">Activity Details</h2>
          <button className="modal-close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
      </div>

      {/* Modal Body */}
      <div className="modal-body">
        {/* Activity Trigger Event */}
        <div className="modal-card mb-24">
          <div className="modal-card-header">
            <h3 className="fw-semibold mb-0 text-uppercase text-gray-600">
              Activity Trigger Event
            </h3>
          </div>

          <div className="p-24">
            {/* Activity Key */}
            <div className="mb-20">
              <label>Activity Key</label>
              <span className="badge bg-warning text-sm">
                {activityDetails?.activityKey}
              </span>
            </div>

            {/* Reference ID and Reference Model */}
            <div className="row mb-20">
              <div className="col-6">
                <label>Reference ID</label>
                <div className="field-code">{activityDetails?.referenceId || "234567cggh"}</div>
              </div>
              <div className="col-6">
                <label>Reference Model</label>
                <div className="field-value">
                  {activityDetails?.referenceModel || "jobs"}
                </div>
              </div>
            </div>

            {/* Target User ID */}
            <div className="mb-20">
              <label>Target User ID</label>
              <div
                className="badge copyCode-btn"
                onClick={() =>
                  handleCopy(activityDetails?.userId, setCopiedUserId)
                }
              >
                {activityDetails?.userId}
                {copiedUserId ? <CopySuccessIcon /> : <CopyIcon />}
              </div>
            </div>

            {/* Triggered At */}
            <div>
              <label>Triggered At</label>
              <div className="triggered-at">
                <span className="icon">🕐</span>
                <span className="time-text">
                  {activityDetails?.triggeredAt
                    ? moment(activityDetails.triggeredAt).format(
                        "D MMM YYYY, HH:mm",
                      )
                    : "-"}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Metadata */}
        <div className="modal-card mb-24">
          <div className="modal-card-header">
            <h3 className="fw-semibold mb-0 text-uppercase text-gray-600">
              Metadata
            </h3>
          </div>

          <div className="metadata-section p-24">
            <div className="metadata-row ">
              <div className="metadata-field">
                <label>Coupon Code</label>
                <span className="value success">
                  {activityDetails?.metadata?.couponCode || "-"}
                </span>
              </div>
              <div className="metadata-field">
                <label>Discount</label>
                <span className="value">
                  {activityDetails?.metadata?.discount || "-"}
                </span>
              </div>
            </div>

            <div className="metadata-row">
              <div className="metadata-field">
                <label>Quote Count</label>
                <span className="value">
                  {activityDetails?.metadata?.quoteCount || "-"}
                </span>
              </div>
              <div className="metadata-field">
                <label>Job Id</label>
                <span className="value">
                  {activityDetails?.metadata?.jobId ?? "-"}
                </span>
              </div>
            </div>
               <div className="metadata-row ">
              <div className="metadata-field">
                <label>End date time</label>
                <span className="value success">
                  {activityDetails?.metadata?.endDateTime || "-"}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Channel Dispatches */}
        <div className="modal-card mb-0">
          <div className="modal-card-header">
            <h3 className="fw-bold mb-0 text-uppercase text-gray-600">
              Channel Dispatches
            </h3>
          </div>

          <div className="p-24">
            <div className="overflow-auto">
              <table className="channel-table">
                <thead>
                  <tr>
                    <th>Channel</th>
                    <th>Status</th>
                    <th>Provider</th>
                    <th>Message ID</th>
                  </tr>
                </thead>
                <tbody>
                  {channelDispatches?.length > 0 ? (
                    channelDispatches?.map((dispatch, index) => (
                      <tr key={index}>
                        <td>
                          <span
                            className={`channel-badge ${dispatch?.channel?.toLowerCase()}`}
                          >
                            {getChannelIcon(dispatch?.channel)}{" "}
                            {dispatch?.channel}
                          </span>
                        </td>
                        <td>
                          <span className={`status-badge ${getStatusClass(dispatch?.status)}`}>
                            <span className="status-dot"></span>
                            {dispatch?.status}
                          </span>
                        </td>
                        <td>{dispatch?.provider}</td>
                        <td className="message-id">{dispatch?.messageId}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="u-text-align-center u-color-red">
                        No dispatches found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Footer */}
      <div className="modal-footer">
        <button className="btn-outline-light" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default ActivityDetails;
